import { LawIDUserType, Role, RoleType } from "../models/user";
export interface RouteData {
  n: string;
  p: string;
  r?: RoleType[];
  lt?: LawIDUserType[];
}
export interface RouteName {
  NoAccess: RouteData;
  ATCS: ATCSRouteName;
}

export interface ATCSRouteName {
  Home: RouteData;
  LoginPage: RouteData;
  LogoutPage: RouteData;
  Main: RouteData;
  ImpersonateUser: RouteData;
  DashboardMain: RouteData;
  DashboardHome: RouteData;
  FormPartA: RouteData;
  FormPartB: RouteData;
  FormEer: RouteData;
  EEHome: RouteData;
  EESignUp: RouteData;
  EEInactive: RouteData;
  ManageAuthorisedSignatories: RouteData;
}

export const RouteN: RouteName = {
  NoAccess: { n: 'no-access', p: '/no-access' },
  ATCS: {
    Home: { n: 'Home', p: '/home' },
    LoginPage: { n: 'login', p: '/check-auth' },
    LogoutPage: { n: 'logout', p: '/signout' },
    Main: {
      n: 'atcs-home',
      p: '/',
      lt: [
        LawIDUserType.PrincipalTrustCoordinatorTrustContact,
        LawIDUserType.ExternalExaminer,
        LawIDUserType.ToBeExternalExaminer,
      ]
    },
    ImpersonateUser: {
      n: 'atcs-impersondate-user',
      p: '/impersondate-user',
      r: []
    },
    DashboardMain: {
      n: 'atcs-dashboard-main',
      p: '/dashboard',
      lt: [
        LawIDUserType.PrincipalTrustCoordinatorTrustContact,
        LawIDUserType.ExternalExaminer,
        LawIDUserType.ToBeExternalExaminer,
      ]
    },
    DashboardHome: {
      n: 'atcs-dashboard',
      p: '/dashboard/home',
    },
    FormPartA: {
      n: 'atcs-form-part-a',
      p: '/form-part-a'
    },
    FormPartB: {
      n: 'atcs-form-part-b',
      p: '/form-part-b'
    },
    FormEer: {
      n: 'atcs-form-eer',
      p: '/form-eer'
    },
    EEHome: {
      n: 'atcs-ee-home',
      p: '/dashboard/ee-home',
      lt: [
        LawIDUserType.ExternalExaminer,
        LawIDUserType.ToBeExternalExaminer,
      ]
    },
    EESignUp: {
      n: 'atcs-ee-signup',
      p: '/dashboard/ee-signup',
      lt: [
        LawIDUserType.ToBeExternalExaminer,
      ]
    },
    EEInactive: {
      n: 'atcs-ee-inactive',
      p: '/dashboard/ee-inactive',
    },
    ManageAuthorisedSignatories: {
      n: 'manage-authorised-signatories',
      p: '/manage-authorised-signatories',
      lt: [
        LawIDUserType.PrincipalTrustCoordinatorTrustContact,
      ]
    },
    
  }
};
